// glow.ts — A single shared radial-gradient sprite texture (white → transparent),
// tinted per-use and drawn with AdditiveBlending to fake the bloom/glow that gives
// a Stellaris-style galaxy its luminous stars, core, and nebulae without a
// post-processing pass (keeps the dpr=1, no-EffectComposer perf budget).
import { CanvasTexture, SRGBColorSpace } from 'three';

let cached: CanvasTexture | null = null;

export function glowTexture(): CanvasTexture {
  if (cached) {
    return cached;
  }
  const size = 256;
  const canvas = document.createElement('canvas');
  canvas.width = canvas.height = size;
  const ctx = canvas.getContext('2d');
  if (ctx) {
    const r = size / 2;
    const g = ctx.createRadialGradient(r, r, 0, r, r, r);
    // A bright tight core fading through a broad soft halo to nothing — reads as a
    // glowing point when small and a gas cloud when scaled up.
    g.addColorStop(0, 'rgba(255,255,255,1)');
    g.addColorStop(0.12, 'rgba(255,255,255,0.85)');
    g.addColorStop(0.35, 'rgba(255,255,255,0.3)');
    g.addColorStop(0.7, 'rgba(255,255,255,0.06)');
    g.addColorStop(1, 'rgba(255,255,255,0)');
    ctx.fillStyle = g;
    ctx.fillRect(0, 0, size, size);
  }
  const tex = new CanvasTexture(canvas);
  tex.colorSpace = SRGBColorSpace;
  cached = tex;
  return tex;
}
